<template>
  <div class="container mt-4" id="checkout">
    <div v-if="paymentNotPaid">
      <div v-if="isPaymentSuccess" class="mb-4">
        <el-alert title="Payment Status: Success" type="success" effect="dark" show-icon></el-alert>
      </div>
      <div class="checkout-header">
        <strong>PAYMENT</strong>
      </div>
      <div class="checkout-body">
        <div class="row">
          <div class="col-lg-8">
            <div class="checkout-subtitle">
              <strong>
                <i class="material-icons"> description </i>
                Payment Summary</strong
              >
            </div>
            <div v-if="!contactAdmin" class="checkout-payment">
              <div class="grid-content bg-purple-light">
                <data-tables :data="ItemsListInt" layout="table" style="border: 2px solid black">
                  <el-table-column label="Description" min-width="100px">
                    <template slot-scope="scope">
                      {{ scope.row.Item_Description }} <br />
                      <div style="font-size: smaller">{{ scope.row.ItemRemarks }}</div>
                    </template>
                  </el-table-column>

                  <el-table-column v-if="isShow" label="Amount" min-width="50px" align="right">
                    <template slot-scope="scope">
                      {{ scope.row.itemAmount }}
                    </template>
                  </el-table-column>

                  <el-table-column v-if="isShow" label="GST" min-width="50px" align="right">
                    <template slot-scope="scope">
                      {{ scope.row.gstValue }}
                    </template>
                  </el-table-column>

                  <el-table-column v-if="isShow" label="Total" min-width="50px" align="right">
                    <template slot-scope="scope">
                      {{ scope.row.totalValue }}
                    </template>
                  </el-table-column>

                  <el-table-column v-if="!isShow" label="Total incl GST" min-width="60px" align="right">
                    <template slot-scope="scope">
                      {{ scope.row.totalValue }}
                    </template>
                  </el-table-column>
                </data-tables>
              </div>
              <div class="checkout-total">
                <b class="pull-left">Total Amount Payable:</b>
                <div v-if="isShow" class="grid-content bg-purple-light pull-right">
                  <b>{{ currency }}{{ TotalAmountDisplay }}</b>
                </div>
                <div v-else class="grid-content bg-purple-light">
                  <b>{{ currency }}{{ TotalAmountDisplay }}</b>
                </div>
              </div>

              <!--show transaction history-->
              <b style="float: left">Document(s):</b>
              <div class="grid-content bg-purple-light">
                <div class="checkout-total">
                  <a href="#" :style="{ color: uiVariable.color.link2 }" class="pull-left"
                     @click="btnDownloadDocumentClick">Download your invoice here</a>
                </div>
              </div>
              <!--end show transaction history-->

              <div class="checkout-paymentMethod" v-if="proceed === false && isPaymentSuccess === false">
                <b class="checkout-paymentMethod_title d-block mb-3">Select Payment Method:</b>
                <div class="row">
                  <PaymentBox
                    v-if="!hideWithSession && payNowLinkEligible"
                    :hidePaymentItem="hidePaymentItem"
                    :passSelectedPaymentMode="selectedPaymentMode"
                    title="PayNow"
                    custom-class="col-md-4"
                    iconName="fa-qrcode"
                    label="paynow"
                    @handleEmit="handleEmit"
                  >
                    <span>Scan & Pay is the sustainable option and e-receipt will be sent instantaneously to your e-mail!</span>
                    <br><br>
                    <BankLogos />
                  </PaymentBox>

                  <PaymentBox
                    v-if="CardupLink"
                    :hidePaymentItem="hidePaymentItem"
                    :passSelectedPaymentMode="selectedPaymentMode"
                    title="Credit Card"
                    :noBadge="true"
                    custom-class="col-md-4 creditCard"
                    :image="assets.icon.paymentCreditCard"
                    label="creditcard"
                    @handleEmit="handleEmit"
                  >
                    <!--iconName="fa-credit-card "-->
                    <strong class="mb-1">EARN REWARDS</strong>
                    <span>Earn miles, points or cashback when you pay<br />school fees with a credit card</span>
                    <div class="">
                      <img :src="assets.bank.creditCardPayment" />
                    </div>
                    <K2Row justify_content="center" align="center">
                      <span>Powered by</span>
                      <img :src="assets.bank.cardUpWhite" class="ms-2" width="70"
                           v-if="selectedPaymentMode === 'creditcard'" />
                      <img :src="assets.bank.cardUp" class="ms-2" width="70" v-else />
                    </K2Row>
                  </PaymentBox>

                  <PaymentBox
                    :hidePaymentItem="hidePaymentItem"
                    :passSelectedPaymentMode="selectedPaymentMode"
                    title="Bank Transfer"
                    :noBadge="true"
                    custom-class="col-md-4 bankTransfer"
                    iconName="fa-exchange"
                    label="banktransfer"
                    @handleEmit="handleEmit"
                  >
                    <span>Pay directly from your bank—simple, reliable, and convenient.</span>
                  </PaymentBox>
                </div>
              </div>
            </div>
            <div v-else-if="contactAdmin" class="checkout-payment">
              <template>
                <el-alert title="" description="Please contact administrator" type="error" show-icon></el-alert>
              </template>
            </div>
            <div v-if="!isPaymentSuccess">
              <div v-if="isQRCode && selectedPaymentMode == 'paynow' && this.proceed" id="showQR"
                   class="block paymentDetails">
                <!--<div style="text-align: center">-->
                <div align="center">
                  &nbsp;&nbsp;&nbsp; <img :src="payNowQRResult" /><br />
                  <strong>Scan & Pay</strong><br />
                  <span>You will be redirected when payment received</span><br />
                  <span>Scan & Pay is supported by these banks:</span><br /><br />
                  <BankLogos /><br />
                </div>
              </div>
              <PaymentBankDetails
                :propIsBankTransfer="isBankTransfer"
                :propIsJapanSchool="isJapanSchool"
                :propIsDbsVA="isDbsVA"
                :propBankAct="bankAct"
                :propStudentInfo="studentInfo"
                v-if="isBankTransfer || (selectedPaymentMode === 'banktransfer' && isJapanSchool)"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="checkout-subtitle">
              <strong>
                <i class="material-icons">account_circle</i>
                Student's Details
              </strong>
            </div>
            <div class="checkout-info">
              <div class="grid-content">
                <span class="checkout-info_title"> School: </span>
                <b style="color: #0e0eff">{{ school_Name }}</b>
              </div>
              <div class="grid-content">
                <span class="checkout-info_title"> Child's Name: </span>
                <b style="color: #0e0eff">{{ student_Name }}</b>
              </div>
              <div class="grid-content" v-if="!isJapanSchool">
                <span class="checkout-info_title"> Programme: </span>
                <b style="color: #0e0eff">{{ Batch }}</b>
              </div>
              <div class="grid-content">
                <span class="checkout-info_title"> Payee Name: </span>
                <b style="color: #0e0eff">{{ PayeeName }}</b>
              </div>
              <div class="grid-content">
                <span class="checkout-info_title"> Invoice No: </span>
                <b style="color: #0e0eff">{{ Invoice_name }}</b>
              </div>
              <div class="grid-content">
                <span class="checkout-info_title"> Invoice Due Date: </span>
                <b style="color: #0e0eff">{{ InvoiceDueDate }}</b>
              </div>
            </div>

            <br />
            <div class="checkout-info" v-if="!isJapanSchool">
              <div class="grid-content">
                <span class="checkout-info_title">FAQ:</span>
                <a :href="payNowPdfLink" target="_blank" :style="{ color: uiVariable.color.link2 }">How to pay via
                  PayNow?</a><br />
                <a :href="creditCardPdfLink" target="_blank" :style="{ color: uiVariable.color.link2 }">How to pay via
                  Credit Card?</a><br />
                <a :href="bankTransferPdfLink" target="_blank" :style="{ color: uiVariable.color.link2 }">How to pay via
                  Bank Transfer?</a>
              </div>
            </div>

            <div v-if="paymentNotPaid">
              <div v-if="!contactAdmin">
                <el-button
                  type="primary"
                  v-on:click="btnProceedPaymentClick()"
                  v-if="!isPaymentSuccess && !isJapanSchool"
                  class="payment-payBtn"
                  :loading="btnLoading"
                  style="background: #dc3545; border-color: #dc3545"
                  :style="isBankTransfer ? 'background:#909399;border-color:#909399;' : 'background:#dc3545'"
                  :disabled="selectedPaymentMode === '' || isBankTransfer"
                >
                  <span v-if="btnLoading">Awaiting Payment</span>
                  <strong style="font-size: 17px; text-transform: uppercase; text-shadow: #00000057 0 0 7px" v-else>
                    Proceed Payment </strong>
                </el-button>
                <el-button type="info" v-on:click="cancelPaymentClick()" v-if="!isPaymentSuccess" class="payment-payBtn"
                           :disabled="selectedPaymentMode === ''">
                  Cancel
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </div>

    <div v-if="!paymentNotPaid">
      <div>
        <el-row>
          <el-col :span="24">
            <div class="grid-content">
              <K2AnimationCheck />
              <h3 style="font-weight: normal; font-family: Gabriola">Thank you for your payment.</h3>
              <p style="margin-bottom: 0px">
                <small>Please check your email for e-receipt shortly.</small>
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <K2Modal :fullscreen="false" :dialog="modal === 'message'" width="600px" :hideFooter="true" :hideHeader="true">
      <K2Row justify_content="flex-start" class="pb-4" flex_direction="column" align="center">
        <K2Row justify_content="center" align="center" class="mb-2">
          <K2Icon name="warning" font-size="20px" style="margin-right: 10px" />
          <K2Text bold="true" :font-size="uiVariable.fontSize.xl">Error</K2Text>
        </K2Row>
        <K2Text style="white-space: pre-line">
          {{ message }}
        </K2Text>
      </K2Row>
    </K2Modal>
  </div>
</template>
<script>
import DataSource from "../../data/datasource";
import Cookies from "js-cookie";
import { saveAs } from "file-saver";
import K2Text from "../../uiComponents/k2Text/k2Text";
import uiVariable from "../../config/uiVariable";
import K2AnimationCheck from "../../uiComponents/k2Animation/checkAnimation";
import assets from "../../assets/assets";
import K2Row from "../../uiComponents/k2Row/k2Row";
import PaymentBox from "./component/paymentBox";
import K2Modal from "../../uiComponents/k2Modal/k2Modal";
import K2Icon from "../../uiComponents/k2Icon/k2MAIcon";
import ConfigAdmin from "../../config/configAdmin";
import moment from "moment/moment";
import PaymentBankDetails from "@/pages/payment/component/paymentBankDetails";
import "./payment.scss";
import { isBetweenDate } from "@/helper/utily";
import BankLogos from "@/pages/payment/BankLogos.vue";

export default {
  name: "Payment",
  components: { BankLogos, PaymentBankDetails, K2Icon, K2Modal, PaymentBox, K2Row, K2AnimationCheck, K2Text, BankLogos },
  data() {
    return {
      message: ConfigAdmin.payment.invoiceExpired,
      assets: assets,
      uiVariable: uiVariable,
      //Page load
      paymentNotPaid: true,
      hidePaymentItem: false,
      contactAdmin: false,
      modal: null,
      //FAQ Link
      payNowPdfLink: 'https://beacon.etonhouse.com/files/QRPayment.pdf',
      creditCardPdfLink: 'https://beacon.etonhouse.com/files/CreditCardPayment.pdf',
      bankTransferPdfLink: 'https://beacon.etonhouse.com/files/BankTransferGuide.pdf',
      //hide or show paynowlink
      payNowLinkEligible: false,
      payNowLink: "",
      //
      //For "Bank Transfer" only
      bankAct: {
        bankAccName: "",
        bankAccNO: "",
        bankName: "",
        bankBranch: "",
        bankCode: "",
        bankBranchCode: "",
        bankSwiftCode: ""
      },
      isJapanSchool: false,
      isBankTransfer: false,
      //For "Bank Transfer" only

      isPaymentSuccess: false,
      isPaymentPending: false,
      btnLoading: false,
      // active:0,
      isPaymentEligible: true,
      isCardupLinkEligible: false,
      isQRCode: false,
      QRImage: "",
      payNowQRResult: "",

      school_Name: "",
      student_Name: "",
      TotalAmount: "",
      TotalAmountDisplay: "",
      selectedPaymentMode: "paynow",
      proceed: false,
      ItemsListInt: [],
      ItemsList: [
        {
          prop: "Item_Description",
          label: "Description"
        }
      ],

      ItemsResp: [],
      encryptedInvName: "",
      encryptedStudID: "",
      isEncrypted: "",
      ID: "",

      Batch: "",
      CardupLink: "",
      ClassName: "",
      PayeeName: "",

      loginType: "",
      Invoice_name: "",
      InvoiceDueDate: "",
      isShow: true,
      hideWithSession: false,
      isDbsVA: false,
      studentInfo: null,
      currency: "$"
    };
  },
  watch: {
    isJapanSchool: function(val) {
      if (val) {
        this.currency = "¥";
      } else {
        this.currency = "$";
      }
    }
  },
  async mounted() {
    this.$vs.loading();
    this.isMobile();
    this.ID = decodeURI(this.$route.query.ID);
    this.isEncrypted = "yes";
    await this.pageLoadCheckPaymentStatus();
    await this.BindStudentPaymentDetail();
    this.$vs.loading.close();
    this.loginType = Cookies.get("userTypeSession");
    this.hideWithinSession();
  },
  methods: {
    hideWithinSession(fromPaymentClick) {
      let startDate = moment("20/04/2024 23:59:59" + " +0800", "DD/MM/YYYY HH:mm:ss Z");
      let endDate = moment("21/04/2024 06:01:00" + " +0800", "DD/MM/YYYY HH:mm:ss Z");

      if (isBetweenDate(startDate, endDate)) {
        this.hideWithSession = true;
        setTimeout(this.hideWithinSession, 30000);
        if (fromPaymentClick && this.selectedPaymentMode === "paynow") {
          return true;
        }
      } else {
        this.hideWithSession = false;
      }
    },
    async BindItemDetails() {
      try {
        const resp = await DataSource.shared.getPayNowItems(this.encryptedInvName, this.encryptedStudID, this.isEncrypted, this.ID);
        if (resp) {
          switch (resp.code) {
            case "99":
              this.$notify.error({
                title: "Error",
                message: "Please contact administrator"
              });

              break;

            case "2":
              //todo : hide button and show contact admin
              this.contactAdmin = true;
              this.isPaymentSuccess = false;
              this.paymentNotPaid = true;
              //todo : hide button and show contact admin

              this.$notify.error({
                title: "Error",
                message: "Please contact administrator"
              });

              //todo hide payNow and bank Transfer button
              this.hidePaymentItem = true;

              break;

            default:
              this.ItemsResp = resp.Table;
              this.ItemsResp.forEach(m => {
                if (m.SPD_ID == "TOTAL") {
                  this.TotalAmount = m.totalValue.replace(",", "");
                  this.TotalAmountDisplay = m.totalValue;
                } else {
                  this.ItemsListInt.push(m);
                }
              });
          }
        }
      } catch (e) {
        this.results = e;
      }
    },
    async getPaymentMode() {
      try {
        // console.log(this.selectedPaymentMode);
        this.btnLoading = false;
        if (this.selectedPaymentMode !== "banktransfer") {
          this.isBankTransfer = false;
        }
      } catch (e) {
        this.results = e;
      }
    },
    handleEmit(value, name) {
      this.$data[name] = value;
    },
    cancelPaymentClick() {
      this.proceed = false;
      this.btnLoading = false;
      this.selectedPaymentMode = "paynow";
      this.isBankTransfer = false;
      this.payNowQRResult = "";
    },
    async btnProceedPaymentClick() {
      if (this.hideWithinSession(true)) {
        this.$notify.error({
          title: "Error",
          message: "PayNow services will not be available during 21 April 2024 12:00 AM - 06:00 AM (SGT)"
        });
        return;
      }
      try {
        this.proceed = true;
        if (!this.selectedPaymentMode) {
          this.$notify.error({
            title: "Error",
            message: "Please select payment method"
          });
        } else {
          if (this.selectedPaymentMode === "paynow") {
            this.$vs.loading();
            this.isQRCode = true;
            //todo get QR code
            let resp;
            if (this.isDbsVA) {
              resp = await DataSource.shared.getQRCodeNew(this.TotalAmount, this.Invoice_name, this.studentInfo?.SchoolUEN, this.studentInfo?.SchoolName);
            } else {
              resp = await DataSource.shared.getQRCode(this.encryptedInvName, this.encryptedStudID, this.TotalAmount, this.isEncrypted, this.ID);
            }
            switch (resp.code) {
              case "99":
                this.$notify.error({
                  title: "Error",
                  message: "Error"
                });
                break;

              default:
                //payNow result in base64 format
                if (this.isDbsVA) {
                  this.payNowQRResult = resp?.url;
                  this.$vs.loading.close();
                } else {
                  this.QRImage = resp.code;
                  let qrImage = "";
                  qrImage = this.QRImage;

                  //s = s.substring(0, s.length - 1) //removes last character
                  qrImage = qrImage.substring(0, qrImage.length - 1);
                  qrImage = qrImage.substring(1, qrImage.length - 0);
                  this.payNowQRResult = qrImage;
                  this.btnLoading = true;
                  this.$vs.loading.close();
                }
            }

            //todo check payment success or failed
            this.checkPaymentStatus();
          } else if (this.selectedPaymentMode == "creditcard") {
            this.isPaymentSuccess = false;
            this.proceed = false;

            this.$confirm(
              "EtonHouse works with a third-party platform, CardUp, to securely process credit card payments. The benefits include being able to use your preferred credit card, to defer cash outflow up to 2 months, " +
              "and to be eligible to earn card rewards such as airmiles and cashback.<br/><br/>" +
              "By clicking 'OK' you will be taken to a checkout page, where a non-refundable processing fee will be displayed. You may review this amount before completing your transaction.<br/><br/>" +
              "Click 'BACK' if you wish to reselect your payment method.<br/><br/>" +
              "-----<br/><br/>" +
              "To learn more about CardUp, visit <a href='www.cardup.co/etonhouse'>www.cardup.co/etonhouse</a>",
              "Credit card payments with CardUp",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "OK",
                cancelButtonText: "BACK",
                type: "warning"

                // this.$confirm("By clicking 'OK', you have agreed to pay the additional non-refundable fees that will be charged by CardUp.<br/><br/>" +
                //   "The additional non-refundable fees will be displayed as \"CardUp Fee\" before clicking \"CONFIRM AND PAY\" in CardUp portal.<br/><br/>" +
                //   "Click 'BACK' if you wish to reselect your payment option.\n", "Alert", {
                //   dangerouslyUseHTMLString: true,
                //   confirmButtonText: "OK",
                //   cancelButtonText: "BACK",
                //   type: "warning"
              }
            )
              .then(() => {
                this.$vs.loading();
                //todo card up - this.CardupLink
                // window.location.href = "https://"+"cardup.co/etonhouse";
                //window.location.href = "https://" + this.CardupLink;
                DataSource.shared.getCardUpURL(this.encryptedInvName, this.encryptedStudID, this.TotalAmount, this.isEncrypted, this.ID).then(resp => {
                  if (resp.code === "88") {
                    window.location.replace("/");
                  } else if (resp.code === "99") {
                    this.$notify.error({
                      title: "Error",
                      message: "Error!"
                    });
                  } else if (resp.code === "3") {
                    //checkout link empty
                    // window.location.href = '';
                    this.$notify.error({
                      title: "Error",
                      message: "Please contact administrator."
                    });
                    this.proceed = false;
                    this.btnLoading = false;
                    this.selectedPaymentMode = "";
                    this.isBankTransfer = false;
                    this.payNowQRResult = "";
                  } else {
                    window.location.href = resp?.code;
                  }
                });
                this.$vs.loading.close();
              })
              .catch(() => {
                this.cancelPaymentClick();
                this.$message({
                  type: "info",
                  message: "Cancelled"
                });
              });
          } else if (this.selectedPaymentMode == "banktransfer") {
            this.showBankTransfer();
          }
        }
      } catch (e) {
        this.results = e;
      }
    },
    async BindStudentPaymentDetail() {
      try {
        const resp = await DataSource.shared.getPaymentGatewayStudentDetail(
          this.encryptedInvName,
          this.encryptedStudID,
          this.TotalAmount,
          this.isEncrypted,
          "invoice",
          this.ID
        );
        if (resp) {
          const info = (this.studentInfo = resp.Table[0]);
          this.isDbsVA = info.PayNowLink?.includes("payment.etonhouse.com");

          if (info.Invoice_name.includes("IN23")) {
            this.modal = "message";
          }
          this.Batch = info.Batch;
          this.school_Name = info.SchoolName;
          if (info.CardupLink) {
            this.CardupLink = info.CardupLink;
            this.isCardupLinkEligible = true;
          }
          if (info.PayNowLink) {
            this.payNowLinkEligible = true;
            this.payNowLink = info.PayNowLink;
          }
          this.ClassName = info.ClassName;
          this.student_Name = info.StudentName;
          this.PayeeName = info.PayeeName;
          this.Invoice_name = info.Invoice_name;
          this.isJapanSchool = info.Invoice_name?.includes("JP-");
          this.InvoiceDueDate = info.InvoiceDueDate;

          //For "Bank Transfer" only:start
          if (this.isDbsVA) {
            this.bankAct = {
              bankAccName: info.AccountName,
              bankAccNO: info.AccountNo,
              bankName: "DBS Bank",
              bankBranch: "",
              bankCode: "",
              bankBranchCode: "",
              bankSwiftCode: info.SwiftCode,
              bankAddress: "12 Marina Boulevard, DBS Asia Central, Marina Bay Financial Centre Tower 3, Singapore 018982",
              bankCountry: "Singapore"
            };
          } else {
            this.bankAct = {
              bankAccName: info.AccountName,
              bankAccNO: info.AccountNo,
              bankName: info.BankName,
              bankBranch: info.BankBranch,
              bankCode: info.BankCode,
              bankBranchCode: info.BranchCode,
              bankSwiftCode: info.SwiftCode
            };
          }
          //For "Bank Transfer" only:end
        }
      } catch (e) {
        this.results = e;
      }
    },
    async pageLoadCheckPaymentStatus() {
      try {
        const resp = await DataSource.shared.getPaymentStatus(this.encryptedInvName, this.encryptedStudID, this.TotalAmount, this.isEncrypted, this.ID);
        if (resp) {
          if (resp.code === "1") {
            //todo: payment already paid/success(hide payment summary and show success)
            this.isPaymentSuccess = true;
            this.paymentNotPaid = false;
          } else if (resp.code === "99") {
            //todo: trigger user to contact administrator
            this.contactAdmin = true;
            this.isPaymentSuccess = false;
            this.paymentNotPaid = true;
          } else {
            //todo:Pending payment(Continue to payment page)
            this.isPaymentSuccess = false;
            this.paymentNotPaid = true;
            //todo
            await this.BindItemDetails();
          }
        }
      } catch (e) {
        this.results = e;
      }
    },

    async checkPaymentStatus() {
      try {
        this.isPaymentSuccess = false;
        let i = 0;

        const self = setInterval(() => {
          DataSource.shared.getPaymentStatus(this.encryptedInvName, this.encryptedStudID, this.TotalAmount, this.isEncrypted, this.ID).then(resp => {
            if (resp) {
              //todo to change back resp.code ==1 , temp hardcode to value '1';
              // if (i === 5) {
              //     this.btnLoading = false;
              //     this.isPaymentSuccess = true;
              //     this.proceed = false;
              //     this.isQRCode = false;
              //     clearInterval(self);
              // }
              if (resp.code === "1") {
                this.btnLoading = false;
                this.isPaymentSuccess = true;
                this.proceed = false;
                this.isQRCode = false;
                this.paymentNotPaid = false;
                clearInterval(self);
              } else if (resp.code === "99") {
                //todo: trigger user to contact administrator
                this.contactAdmin = true;
                this.isPaymentSuccess = false;
                this.paymentNotPaid = true;
                this.proceed = false;
                this.isQRCode = false;
                clearInterval(self);
              }
            }
          });

          i++;
        }, 1000);
      } catch (e) {
        this.results = e;
      }
    },

    async showBankTransfer() {
      try {
        this.isBankTransfer = true;
        if (this.isDbsVA) {
          // todo check payment success or failed
          await this.checkPaymentStatus();
        }
      } catch (e) {
        this.results = e;
      }
    },

    async btnDownloadDocumentClick() {
      try {
        const resp = await DataSource.shared.getPaymentDocumentZip(this.encryptedInvName, this.encryptedStudID, this.isEncrypted, this.ID);
        if (resp.code === "99") {
          this.$notify.error({
            title: "Error",
            message: "Cannot download files!"
          });
        } else {
          let byteChar = atob(resp.code);
          let byteNo = new Array(byteChar.length);
          for (let i = 0; i < byteChar.length; i++) {
            byteNo[i] = byteChar.charCodeAt(i);
          }
          let byteArray = new Uint8Array(byteNo);
          let file = new Blob([byteArray], { type: "application/zip;base64" });
          let fileUrl = URL.createObjectURL(file);
          var currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
          let zipFilename = "zip-" + currentDate + ".zip";
          // window.location.href = fileUrl; //change to above using saveAs - because safari cannot direct for zip
          saveAs(fileUrl, zipFilename); //can support for safari as well
        }
      } catch (e) {
        this.results = e;
      }
    },

    //todo: reserved
    async displayQRCodeImage(base64string) {
      if (base64string) {
        this.isQRCode = true;
      }
      var byteChar = atob(base64string);
      var byteNo = new Array(byteChar.length);
      for (var i = 0; i < byteChar.length; i++) {
        byteNo[i] = byteChar.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNo);
      var file = new Blob([byteArray], { type: "image/png;base64" });
      var fileUrl = URL.createObjectURL(file);
    },
    isMobile() {
      let screenWidth = window.innerWidth;
      if (screenWidth <= 770) {
        this.isShow = false;
        // return true;
      } else {
        this.isShow = true;
        // return false;
      }
    }
  },
  created() {
    window.addEventListener("resize", this.isMobile);
  },
  destroyed() {
    window.removeEventListener("resize", this.isMobile);
  }
};
</script>
<style scoped>
.el-header {
  background-color: orange;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.data-tables {
  border: 1px solid black;
}

.checkout-header {
  color: #007bff;
  border-bottom: 1px solid;
  margin-bottom: 20px;
  background: white;
  padding: 12px;
  text-align: left;
}

.checkout-info {
  background: white;
  padding: 20px;
  text-align: left;
  line-height: 28px;
  color: #575255;
  box-shadow: 0 10px 6px -8px #dcdfe3;
  border-radius: 3px;
}

.checkout-info b {
  color: #606266 !important;
  font-weight: 500;
}

span.checkout-info_title {
  min-width: 100px;
  display: block;
  color: #333333;
  font-weight: 600;
}

.checkout-subtitle i {
  color: #007bff;
  font-size: 2em;
}

.checkout-subtitle {
  text-align: left;
  margin: 10px 0;
}

.checkout-payment {
  background: white;
  padding: 20px;
  border-radius: 3px;
  /*display: table;*/
  box-shadow: 0 10px 6px -8px #dcdfe3;
  width: 100%;
}

.checkout-payment .sc-table {
  border: 1px solid #edf0f4 !important;
  margin-bottom: 20px;
}

.checkout-total {
  display: table;
  width: 100%;
  margin-bottom: 20px;
  background: #f2f2f7;
  padding: 10px 15px;
  border-radius: 3px;
}

.checkout-total b {
  color: #007bff;
}

.checkout-total span {
  color: #909399;
}

.checkout-paymentMethod {
  text-align: left;
}

.payment-payBtn {
  width: 100%;
  margin: 10px 0 0 !important;
}

.payment-payBtn span {
  font-weight: normal !important;
}

.ql-bg-green {
  background: lightgreen;
}
</style>
